<template>
  <div class="my-note">
    <result-size
      :title="this.title"
      :icon="require('@/assets/images/userPage/write.png')"
      :curPage="this.curPage"
      :resultNum="this.resultNum"
      :pageNum="this.pageNum"
      :pageSize="this.pageSize"
      @changeCurPage="handleChangeCurPage"
      @changePageSize="handleChangePageSize"
    ></result-size>
    <div class="tool-bar">
      排序：
      <button
        @click="handleSortByName"
        :class="{ active: (active === 11) | (active === 12) }"
      >
        书名
        <img
          :src="require('@/assets/images/icons/arrow-up.png')"
          v-if="active === 11"
        />
        <img
          :src="require('@/assets/images/icons/arrow-up(1).png')"
          v-else-if="active === 12"
        />
      </button>
      <button
        @click="handleSortByTime"
        :class="{ active: (active === 21) | (active === 22) }"
      >
        笔记时间
        <img
          :src="require('@/assets/images/icons/arrow-up.png')"
          v-if="active === 21"
        />
        <img
          :src="require('@/assets/images/icons/arrow-up(1).png')"
          v-else-if="active === 22"
        />
      </button>
    </div>
    <div class="note-list"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading">
      <note-card
        v-for="item in noteList"
        :key="item.id"
        data-warden-title="显示文章内容"
        :data-warden-info="item.bookName"
        :data-warden-bookId="item.bookId"
        :note="item"
        @deleteNote="handleDeleteNote(item)"
        @editNote="handleEditNote(item)"
      />
    </div>
    <div class="page-bar">
      <page-bar
        :curPage="this.curPage"
        :pageNum="this.pageNum"></page-bar>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearHistory"
    >
      确认清空这条笔记？
    </my-dialog>
  </div>
</template>

<script>
import NoteCard from '@/components/NoteCard.vue'
import PageBar from '../../components/PageBar.vue'
import ResultSize from '../../components/ResultSize.vue'
import MyDialog from '../../components/MyDialog.vue'
export default {
  name: 'MyNote',
  components: { NoteCard, PageBar, MyDialog, ResultSize },
  data () {
    return {
      active: 21,
      title: '我的笔记',
      noteList: [],
      resultNum: 0,
      pageNum: 0,
      curPage: 1,
      storeId: 0,
      pageSize: 10,
      loading: true
    }
  },
  methods: {
    handleSortByName () {
      if (this.active === 11) {
        this.active = 12
      } else {
        this.active = 11
      }
      this.getNote()
    },
    handleSortByTime () {
      if (this.active === 21) {
        this.active = 22
      } else {
        this.active = 21
      }
      this.getNote()
    },
    // 删除笔记
    handleDeleteNote (item) {
      this.$refs.messageDialog.open(() => {
        let url = 'retrieve/notes/deleteOneNotesById?noteId=' + item.noteId
        this.noteList.pop(item)
        this.$http.post(url).then(
          res => {
            console.log('删除成功')
            this.getNote()
          },
          err => {
            console.log('删除失败')
          }
        )
      })
    },
    // 跳转图书详情页面
    handleEditNote (item) {
      // console.log(item)
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {book: item.bookId, page: item.page, note: true}
      })
      window.open(routeUrl.href, '_blank')
    },
    clearHistory () {
      this.$refs.messageDialog.close()
      this.noteList = this.noteList.filter(item => item.id !== this.toDeleteId)
    },
    // 获取笔记
    getNote () {
      this.noteList = []
      this.loading = true
      let order, orderMethod
      if (this.active === 11 || this.active === 12 || this.active === 0) {
        order = 'bookName'
      } else {
        order = 'time'
      }
      if (this.active === 11 || this.active === 21 || this.active === 0) {
        orderMethod = 'DESC'
      } else {
        orderMethod = 'ASC'
      }
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/notes/getAllNotesByOrder'
      let params = {
        pageNum: this.curPage,
        pageSize: this.pageSize,
        userId: userId,
        order: order,
        orderMethod: orderMethod
      }
      this.$http.get(url, {params: params}).then(
        res => {
          console.log(res.data.data)
          this.loading = false
          this.resultNum = res.data.data.totalCount
          this.pageNum = Math.ceil(this.resultNum / this.pageSize)
          let tmp = res.data.data.bookNoteList
          for (let i in tmp) {
            let element = tmp[i]
            // 处理备注换行问题
            let arr = element.notes.notes.split(/[\n]/)
            let tmpnote = ''
            for (let i = 0; i < arr.length - 1; i++) {
              tmpnote = tmpnote + arr[i] + '\n   '
            }
            tmpnote = tmpnote + arr[arr.length - 1]
            tmp[i] = {
              id: i,
              bookId: element.bookInfo.id,
              bookName: element.bookInfo.bookName,
              bookAuthor: element.bookInfo.author,
              bookCover: require('@/assets/images/bookCover/u553.jpg'),
              bookEdition: element.bookInfo.edition,
              bookNote: tmpnote,
              noteId: element.notes.id,
              bookNoteTime: element.notes.updateTime,
              page: element.notes.page,
              from: element.bookInfo.bookName + '第' + element.notes.page + '页'
            }
            let url = '/retrieve/page/getImage'
            let params = {
              bookId: element.bookInfo.id,
              page: 1
            }
            this.$http({
              method: 'get',
              url: url,
              params: params,
              responseType: 'blob'
            }).then(res => {
              const binaryData = []
              binaryData.push(res.data)
              const url = window.URL.createObjectURL(
                new Blob(binaryData, { type: 'image/jpg' })
              )
              tmp[i].bookCover = url
              // this.noteList.push(note)
            })
            // .catch(err => {
            //   this.noteList.push(note)
            // })
          }
          this.noteList = tmp
        },
        err => {
          alert(err.message)
          console.log(err)
        }
      )
    },
    handleChangeCurPage (page) {
      this.curPage = page
      this.getNote()
    },
    handleChangePageSize (size) {
      this.pageSize = size
      if (this.curPage !== 1) {
        this.curPage = 1
      }
      this.getNote()
    }
  },
  created () {
    this.getNote()
  }
}
</script>

<style scoped>
.my-note {
  padding: 0 20px;
  padding-top: 10px;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.result-size >>> .icon-image {
  height: 34px;
  margin-top: -18px;
  margin-bottom: -20px;
  margin-right: -8px;
}

.tool-bar {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: right;
  height: 40px;
  color: #9e5c1d;
  background-color: #f4f2f1;
  margin-bottom: 15px;
}

.tool-bar button {
  margin-left: 10px;
  border: 0;
  background-color: #e5e1de;
  color: #634c37;
  height: 25px;
  width: 90px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-bar button.active {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  background-color: #9e5c1d;
  color: #fff;
  min-width: 90px;
  width: max-content;
}

.tool-bar button img {
  width: 10px;
  margin-left: 5px;
}

.note-list {
  height: 630px;
  overflow-y: scroll;
}

.note-list >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.note-list >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: auto;
  margin-bottom: 10px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}
</style>



// WEBPACK FOOTER //
// src/views/user/MyNote.vue